module.exports = __webpack_public_path__ + "static/media/thelastofus2.99bb36c5.jpg";